import { v4 as uuidv4 } from 'uuid';

const formatComboBets = (rawSelections, stake) => {
  const selections = rawSelections.reduce((acc, selection) => {
    if (!selection.active) return acc;

    acc.push({
      type: selection.type === 'bet_builder' ? 'CUSTOM' : 'REGULAR',
      odds: selection.odds,
      banker: false,
      game: selection.game,
      eventMarketOutcomes: [...selection.markets].map(([, outcome]) => {
        return {
          eventId: selection.eventId,
          eventMarketId: outcome.marketId,
          eventMarketOutcomeId: outcome.outcomeId,
          odds: outcome.odds,
        };
      }),
    });
    return acc;
  }, []);

  return [
    {
      selectedSystems: [selections.length],
      payin: {
        stake: {
          type: 'TOTAL',
          amount: stake,
        },
        total: stake,
      },
      selections,
    },
  ];
};

const formatSingleBets = (selections, stake) => {
  const splitStake = parseFloat((parseFloat(stake) / selections.length || 1).toFixed(2));

  return selections.reduce((acc, selection) => {
    if (!selection.active) return acc;

    acc.push({
      selectedSystems: [1],
      payin: {
        stake: {
          type: 'TOTAL',
          amount: selection.payment || splitStake,
        },
        total: selection.payment || splitStake,
      },
      selections: [
        {
          type: selection.type === 'bet_builder' ? 'CUSTOM' : 'REGULAR',
          odds: selection.odds,
          banker: false,
          game: selection.game,
          eventMarketOutcomes: [...selection.markets].map(([, outcome]) => {
            return {
              eventId: selection.eventId,
              eventMarketId: outcome.marketId,
              eventMarketOutcomeId: outcome.outcomeId,
              odds: outcome.odds,
            };
          }),
        },
      ],
    });
    return acc;
  }, []);
};

const formatSystemBets = (selections, stake, systems) => {
  const selectionList = Object.values(selections ?? {});
  const systemsList = Object.values(systems ?? {}).filter((system) => system.selected) || [];

  const stakePerSystem = systemsList.filter((system) => system.stake);

  if (!systemsList.length) return;
  const numOfBankers = selectionList.filter(
    (selection) => selection.active && selection.banker,
  ).length;

  if (stakePerSystem?.length <= 1) {
    return [
      {
        selectedSystems: [systemsList.reduce((acc, n) => (acc += +n.id), numOfBankers)],
        payin: {
          stake: {
            type: 'TOTAL',
            amount: stake,
          },
          total: stake,
        },
        selections: selections.reduce((acc, selection) => {
          if (!selection.active) return acc;

          acc.push({
            type: selection.type === 'bet_builder' ? 'CUSTOM' : 'REGULAR',
            odds: selection.odds,
            banker: selection.banker || false,
            game: selection.game,
            eventMarketOutcomes: [...selection.markets].map(([, outcome]) => {
              return {
                eventId: selection.eventId,
                eventMarketId: outcome.marketId,
                eventMarketOutcomeId: outcome.outcomeId,
                odds: outcome.odds,
              };
            }),
          });

          return acc;
        }, []),
      },
    ];
  }

  return systemsList.map((system) => ({
    selectedSystems: [system.id + numOfBankers],
    payin: {
      stake: {
        type: 'TOTAL',
        amount: system.stake || 1,
      },
      total: system.stake || 1,
    },
    selections: selectionList.reduce((acc, selection) => {
      if (!selection.active) return acc;

      acc.push({
        type: 'REGULAR',
        odds: selection.odds,
        banker: selection.banker || false,
        game: selection.game,
        eventMarketOutcomes: [...selection.markets].map(([, outcome]) => {
          return {
            eventId: selection.eventId,
            eventMarketId: outcome.marketId,
            eventMarketOutcomeId: outcome.outcomeId,
            odds: outcome.odds,
          };
        }),
      });
      return acc;
    }, []),
  }));
};

export function formatBetForBetslipPlacement({
  selectionsData,
  stake,
  systems,
  selectedTicketType,
}) {
  const selections = Object.values(selectionsData ?? {});
  if (!selections.length) return {};

  const betslip = {
    reqUuid: uuidv4(),
    currency: window.currency,
    language: window.languageCode,
  };

  switch (selectedTicketType) {
    case 'combo':
      betslip.bets = formatComboBets(selections, stake);
      break;
    case 'single':
      betslip.bets = formatSingleBets(selections, stake);
      break;
    case 'system':
      betslip.bets = formatSystemBets(selections, stake, systems);
      break;
    default:
      betslip.bets = formatComboBets(selections, stake);
  }

  return betslip;
}
